import { render, staticRenderFns } from "./AuthTable.vue?vue&type=template&id=4552fcbd&scoped=true"
import script from "./AuthTable.vue?vue&type=script&lang=js"
export * from "./AuthTable.vue?vue&type=script&lang=js"
import style0 from "./AuthTable.vue?vue&type=style&index=0&id=4552fcbd&prod&lang=scss"
import style1 from "./AuthTable.vue?vue&type=style&index=1&id=4552fcbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552fcbd",
  null
  
)

export default component.exports